import { defineComponent as w, mergeModels as S, ref as V, computed as u, useModel as W, useTemplateRef as A, watch as B, onMounted as E, onUnmounted as F, createElementBlock as P, openBlock as $, Fragment as I, createVNode as v, createBlock as H, createCommentVNode as U, unref as f, withCtx as c, renderSlot as k, createElementVNode as O, mergeProps as j, createTextVNode as q, toDisplayString as z } from "vue";
import i from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Tooltip/tooltip.js";
import G from "./TooltipArrow.vue2.js";
import J from "./TooltipContent.vue2.js";
import K from "../../helpers/FloatingUi.vue2.js";
import Q from "../../helpers/PassThrough.vue2.js";
import { useHtmlElementFromVNodes as X } from "../../use/index.js";
import { useOUIAProps as Y } from "../../helpers/ouia.js";
const re = /* @__PURE__ */ w({
  name: "PfTooltip",
  inheritAttrs: !1,
  __name: "Tooltip",
  props: /* @__PURE__ */ S({
    appendTo: {},
    position: { default: "top" },
    trigger: { default: "mouseenter focus" },
    leftAligned: { type: Boolean },
    entryDelay: { default: 1e3 },
    exitDelay: { default: 0 },
    distance: { default: 15 },
    aria: { default: "describedby" },
    animationDuration: { default: 300 },
    minWidth: {},
    maxWidth: {},
    content: {},
    flip: { type: Boolean, default: !0 },
    ouiaId: {},
    ouiaSafe: { type: Boolean, default: !0 }
  }, {
    visible: { type: Boolean, default: !1 },
    visibleModifiers: {}
  }),
  emits: ["update:visible"],
  setup(g, { expose: M }) {
    const n = g, s = V(!n.animationDuration), T = Y({ id: n.ouiaId, safe: u(() => s.value && n.ouiaSafe) }), o = W(g, "visible"), { element: r, findReference: C } = X(), D = A("tooltipElementRef"), h = u(() => n.trigger.split(" ").includes("mouseenter")), b = u(() => n.trigger.split(" ").includes("focus")), N = u(() => n.trigger.split(" ").includes("click")), R = {
      top: i.modifiers.top,
      bottom: i.modifiers.bottom,
      left: i.modifiers.left,
      right: i.modifiers.right,
      "top-start": i.modifiers.topLeft,
      "top-end": i.modifiers.topRight,
      "bottom-start": i.modifiers.bottomLeft,
      "bottom-end": i.modifiers.bottomRight,
      "left-start": i.modifiers.leftTop,
      "left-end": i.modifiers.leftBottom,
      "right-start": i.modifiers.rightTop,
      "right-end": i.modifiers.rightBottom
    };
    B(o, () => {
      s.value = !n.animationDuration;
    }), B(r, (e, t) => {
      t == null || t.removeEventListener("mouseenter", l), t == null || t.removeEventListener("mouseleave", p), t == null || t.removeEventListener("focus", m), t == null || t.removeEventListener("blur", d), e == null || e.addEventListener("mouseenter", l), e == null || e.addEventListener("mouseleave", p), e == null || e.addEventListener("focus", m), e == null || e.addEventListener("blur", d);
    }), E(() => {
      document.addEventListener("click", L);
    }), F(() => {
      var e, t, a, y;
      document.removeEventListener("click", L), (e = r.value) == null || e.addEventListener("mouseenter", l), (t = r.value) == null || t.addEventListener("mouseleave", p), (a = r.value) == null || a.removeEventListener("focus", m), (y = r.value) == null || y.removeEventListener("blur", d);
    });
    function L(e) {
      N.value && (e.target === r.value ? o.value = !0 : o.value = !1);
    }
    function m() {
      b.value && (o.value = !0);
    }
    function d() {
      b.value && (o.value = !1);
    }
    function l() {
      h.value && (o.value = !0);
    }
    function p() {
      h.value && (o.value = !1);
    }
    return M({
      el: D
    }), (e, t) => ($(), P(I, null, [
      v(Q, { onChildren: f(C) }, {
        default: c(() => [
          k(e.$slots, "default")
        ]),
        _: 3
      }, 8, ["onChildren"]),
      e.$slots.content ? ($(), H(K, {
        key: 0,
        hidden: !o.value,
        "teleport-to": e.appendTo,
        reference: f(r),
        placement: e.position,
        offset: Number(e.distance),
        flip: e.flip,
        "min-width": e.minWidth,
        "animation-duration": e.animationDuration,
        onHidden: t[0] || (t[0] = (a) => s.value = !0),
        onShown: t[1] || (t[1] = (a) => s.value = !0)
      }, {
        default: c(({ placement: a }) => [
          O("div", j({ ref: "tooltipElementRef" }, { ...f(T), ...e.$attrs }, {
            class: [f(i).tooltip, R[a]],
            style: { maxWidth: e.maxWidth },
            role: "tooltip"
          }), [
            v(G),
            v(J, { "left-aligned": e.leftAligned }, {
              default: c(() => [
                k(e.$slots, "content", {}, () => [
                  q(z(e.content), 1)
                ])
              ]),
              _: 3
            }, 8, ["left-aligned"])
          ], 16)
        ]),
        _: 3
      }, 8, ["hidden", "teleport-to", "reference", "placement", "offset", "flip", "min-width", "animation-duration"])) : U("", !0)
    ], 64));
  }
});
export {
  re as default
};
